module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms1_m_en.a22e96b021df34d199be16341eb837be.png";